import { componentDisplayDataSchema } from './schema.component-display-data.js';
import { authenticateComponentFrameworkRequest } from './util.authenticate-component-framework-request.js';

async function fetchComponentDisplayData(referenceId) {
  const url = `${process.env["COMPONENT_FRAMEWORK_API"]}/api/References/GetDisplayInfo/${encodeURIComponent(referenceId)}`;
  const res = await fetch(...authenticateComponentFrameworkRequest(url));
  if (!res.ok) {
    throw new Error("fetchComponentDisplayData(): unable to resolve display data");
  }
  return componentDisplayDataSchema.parse(await res.json());
}

export { fetchComponentDisplayData };
//# sourceMappingURL=request.fetch-component-display-data.js.map
